var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoHabitaculo2Pt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "35px",
    viewBox: "0 0 31 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Habit\xE1culo &gt; 2pt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS-CATEGORIES",
    transform: "translate(-426.000000, -401.000000)",
    stroke: "#00A9FD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.378864,402.966634 C451.230033,401.66812 454.588982,401.591564 454.922066,403.26697 L455.977952,408.468175 C456.308519,410.132645 452.834626,410.795993 451.414194,410.008977 C450.100315,409.281692 449.690042,404.017812 450.378864,402.966634 Z M445.611648,425.651291 C445.453496,422.767809 446.13183,419.752246 447.274133,416.761079 C447.799349,415.386851 448.459225,413.728691 449.399328,412.608528 C450.607912,411.168259 452.151678,410.744255 454.497531,411.430318 C455.417498,411.727709 456.104641,412.324176 455.893632,413.118764 L451.957868,429.066041 C451.261076,431.718593 448.592626,435 445.640174,435 L429.578716,435 C428.573171,435 427.680471,433.17106 427.304598,431.369462 C427.136797,430.563097 426.829722,428.850674 427.119598,427.820528 C427.422058,426.748319 427.959859,426.575857 428.933942,426.45345 C434.114787,425.798094 439.483568,426.387831 444.525558,427.092402 C446.152385,427.372547 445.663246,426.591841 445.611648,425.651291 Z",
    id: "Picto-Habit\\xE1culo->-2pt"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoHabitaculo2Pt);
export default __webpack_public_path__ + "static/media/PictoHabitaculo_2pt.d44eec1077c3a60bb517f3b53a5fc819.svg";
export { ForwardRef as ReactComponent };